import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { Input, Select } from "styled";
import { useQuery } from "react-query";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import { Button } from "styled";
import getFormattedDate from "utils/helpers";
// import { BarChart } from "@mui/x-charts";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Bar, Doughnut, getDatasetAtEvent, getElementAtEvent } from "react-chartjs-2";
import { Box } from "@mui/system";
import { getRandomColor } from "../utils/helpers"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-plugin-datalabels'; // Import the datalabels plugin
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
  Label,
  Sector,
  Tooltip,
} from 'recharts';
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import { useSelector } from "react-redux";
import ModalTable from "components/mobility-dashboard/ModalTable";
import { trackSearchEvent } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";
import { useLocation } from "react-router-dom";

const MobilityDashboard = () => {
  const [selectedFleets, setSelectedFleets] = useState("all");
  const [selectedHubs, setSelectedHubs] = useState("all");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [reportData, setReportData] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [contractType, setContractType] = useState("CPKM");
  const [isMobility, setIsMobility] = useState("");
  const [selectedConfigurations, setSelectedConfigurations] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCPKMSizes, setSelectedCPKMSizes] = useState([]);
  const [selectedCPKMProducts, setSelectedCPKMProducts] = useState([]);
  const [selectedFleetCodes, setSelectedFleetCodes] = useState(null)
  const [summary, setSummary] = useState(null);
  const [fetch, setFetch] = useState(0)
  const [modalData, setModalData] = useState(null)
  const currentUser = useSelector((state) => state.user.currentUser);
  const [selectedWearPercent, setSelectedWearPercent] = useState("");
  const [firstLoad, setFirstLoad] = useState(true);
  const location = useLocation();

    const wearOptions = [
    { label: "All", value: "" },
    { label: "0-25%", value: "0-25%" },
    { label: "25-50%", value: "25-50%" },
    { label: "50-75%", value: "50-75%" },
    { label: "75-100%", value: "75-100%" },
  ]; 

  const { data: allFleets, isLoading: loadingFleets, refetch } = useQuery(
    [
      "customer-fleet",
    ], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      isMobility: true
    })
  );
  const { data: allHubs } = useQuery(
    [
      "customer-hub",
      selectedFleetCodes && selectedFleetCodes
    ], () =>
    getAllData("/customer-hub", {
      ...selectedFleetCodes && { fleetCode: selectedFleetCodes },
      limit: 3000,
    })
  );
  const { data: allConfigurations } = useQuery([`/vehicle-configuration-master`], () =>
    getAllData("/vehicle-configuration-master", {
      limit: 2000,
      page: 1,
    })
  );
  // const { data: allSizes } = useQuery(
  //   [`/sizes`, contractType],
  //   () =>
  //     getAllData("/product/sizes", {
  //       limit: 300,
  //       page: 1,
  //     }),
  //   {
  //     enabled: contractType !== "NON CPKM", // Only fetch data if condition is true
  //   }
  // );
  // const { data: allSizeMasters } = useQuery(
  //   [`/size-master`, contractType],
  //   () =>
  //     getAllData("/size-master", {
  //       limit: 300,
  //       page: 1,
  //     }),
  //   {
  //     enabled: contractType !== "CPKM", // Only fetch data if condition is true
  //   }
  // );
  const { data: allProducts } = useQuery([`product-brands`, contractType], () =>
    getAllData("/product/getBrands", {
      limit: 300,
      page: 1,
    }),
    {
      enabled: contractType !== "NON CPKM", // Only fetch data if condition is true
    }
  );
  const { data: allProductMasters } = useQuery([`/product-master`, contractType], () =>
    getAllData("/product-master", {
      limit: 1000,
      page: 1,
    }),
    {
      enabled: contractType !== "CPKM", // Only fetch data if condition is true
    }
  );

  const getDashboardSummary = async () => {
    setIsLoading(true);
    try {
      // console.log(allFleets)
      // console.log(selectedProducts.flatMap(item=> item.meta.ids))
      const dt = await createDocument("/dashboard/mobility/summary", {
        ...(selectedFleets !== "all" ? {
          fleets: selectedFleets
        } : { fleets: allFleets?.data.map(data => { return data._id }).join(",") }),
        ...(selectedHubs !== "all" ? {
          hubs: selectedHubs
        } : { hubs: allHubs?.data.map(data => { return data._id }).join(",") }),

        ...(selectedConfigurations.length && {
          configurations: selectedConfigurations.map((make) => make).join(","),
        }),
        ...(selectedSizes.length && {
          cpkmtyreSize: selectedSizes.map((make) => make).join(","),
        }),
        ...(selectedCPKMProducts.length && {
          cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(","),
        }),
        ...(selectedProducts.length && {
          products: selectedProducts.filter(item => item.type === "NON CPKM")?.flatMap((make) => make.meta.ids).join(","),
        }),
        ...(contractType && { contractType }),
        ...dateFrom && { dateFrom },
        ...dateTo && { dateTo }
      });
      // console.log({dt})
      setSummary(dt.data)
    } catch (err) {
      // console.log({err})
      setSummary(null);
    } finally {
      setIsLoading(false);
    }
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
            fleetCode: fleet.fleetCode,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    // console.log({selectedHubs})
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        ...(allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
            const selectedFleetsVal = selectedFleets!== "all" ? allFleets?.data?.filter(
              (fleet) => selectedFleets === fleet._id
            ): allFleets
            ?.data;
            return selectedFleetsVal?.some(
              (fleet) => fleet.fleetCode === hub.fleetCode
            );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allHubs, selectedHubs]);


  const getConfigurationOptionss = useCallback(() => {
    if (allConfigurations && allConfigurations.data && allConfigurations.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        ...allConfigurations?.data?.map((config) => {
          return {
            value: config._id,
            label: config.make.makeName + "/" + config.model.name + "/" + config.name,
          };
        }),
      ];
    }
  }, [allConfigurations]);

  const getProductOptions = useCallback(() => {
    if ((allProducts && allProducts.data && allProducts.data.length) || (allProductMasters && allProductMasters.data && allProductMasters.data.length)) {
      return [
        {
          label: "All",
          value: "all",
        },
        ...contractType !== "NON CPKM" && allProducts ? allProducts?.data?.filter(product => product.tyrePattern)?.map((product) => {
          return {
            value: product._id,
            label: product.tyrePattern,
            meta: { ids: product.ids, sizes: product.sizes },
            type: "CPKM"
          };
        }) : [],
        ...contractType !== "CPKM" && allProductMasters ? allProductMasters?.data?.map((product) => {
          return {
            value: product._id,
            label: product.productName,
            meta: { sizes: [product.tyreSize?.name], ids: [product._id] },
            type: "NON CPKM"
          };
        }) : [],
      ];
    }
  }, [allProducts, allProductMasters]);

  // console.log("PRODUCTS", getProductOptions(), selectedProducts)
useEffect(() => {
    if (!allFleets?.data?.length) return;
    if (selectedFleets) return;
    const firstFleet = allFleets.data[0];
    setSelectedFleets(firstFleet._id);
    setSelectedFleetCodes(firstFleet.fleetCode);
  }, [allFleets, selectedFleets]);
  const getSizeOptions = useCallback(() => {
    if ((allProducts && allProducts.data && allProducts.data.length) || (allProductMasters && allProductMasters.data && allProductMasters.data.length)) {
      //       let setObj = new Set(arr.map(JSON.stringify));
      // let output = Array.from(setObj).map(JSON.parse);
      let array = [
        {
          label: "All",
          value: "all",
        },
        ...contractType === "" && !selectedProducts?.length ?
          Array.from(new Set(getProductOptions()?.filter(item => item.value !== "all").flatMap(obj => (obj.meta?.sizes).map(size => ({ name: size, type: obj.type }))).map(JSON.stringify)))?.map(JSON.parse)
            ?.map((size) => {
              return {
                value: size.name,
                label: size.name + "/" + size.type,
                type: size.type
              };
            })
          :
          [...contractType !== "NON CPKM" ?
            selectedCPKMProducts?.length ? Array.from(new Set((selectedCPKMProducts).flatMap(obj => obj.meta.sizes)))
              ?.map((size) => {
                return {
                  value: size,
                  label: size,
                  type: "CPKM"
                };
              }) :
              Array.from(new Set(getProductOptions()?.filter(item => item.type === "CPKM").flatMap(obj => obj.meta.sizes)))
                ?.map((size) => {
                  return {
                    value: size,
                    label: size,
                    type: "CPKM"
                  };
                })
            : [],
          ...contractType !== "CPKM" ?
            selectedProducts?.length ? Array.from(new Set((selectedProducts)?.filter(item => item.type === "NON CPKM").flatMap(obj => obj.meta.sizes)))
              ?.map((size) => {
                return {
                  value: size,
                  label: size,
                  type: "NON CPKM"
                };
              }) :
              Array.from(new Set(getProductOptions()?.filter(item => item.type === "NON CPKM").flatMap(obj => obj.meta.sizes)))
                ?.map((size) => {
                  return {
                    value: size,
                    label: size,
                    type: "NON CPKM"
                  };
                })
            : [],]
      ];
      array.filter(item => item.value)?.sort((a, b) => {
        return a.value?.localeCompare(b?.value) ? -1 : 1
      });
      return array;

    } else return [];
  }, [allProducts, allProductMasters, selectedCPKMProducts]);


  // console.log("sizes", getSizeOptions())

  const fleetTypes = [
    { label: "All", value: "" },
    { label: "Mobility", value: true },
    { label: "Fleet", value: false },
  ];
  const contractTypes = [
    { label: "All", value: "" },
    { label: "CPKM", value: "CPKM" },
    { label: "Service Contract", value: "NON CPKM" },
  ];

  const clickSearchBtn = () => {
    const params = {
      fleets: selectedFleets === "all" ? "All" : getFleetOptions()?.find((item) => item.value === selectedFleets)?.label,
      hubs: selectedHubs === "all" ? "All" : getHubOptions()?.find((item) => item.value === selectedHubs)?.label,
      contract_type: contractType || "All",
      from_date: dateFrom,
      to_date: dateTo,
      tyre_size: selectedSizes,
      configurations: selectedConfigurations?.map(
        (id) => getConfigurationOptionss()?.find((item) => item.value === id)?.label ?? id
      ),
      percentage_wear: selectedWearPercent || "All",
      tyre_patterns: selectedProducts?.map((p) => p?.label),
    };

    trackSearchEvent(ANALYTICS_EVENTS.CLICK_SEARCH_BUTTON, "Mobility Technical", location.pathname, params);
  };

  useEffect(() => {
    setFirstLoad(false);
    if (isLoading === false && firstLoad === false) {
      trackSearchEvent(ANALYTICS_EVENTS.SYS_RESULT_LOADED, "Mobility Technical", location.pathname, {});
    }
  }, [isLoading]);

  return (
    <div>
      <div className="w-full px-8 grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-5 justify-center items-end gap-x-4 gap-y-2 mb-4">
        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Select Fleet
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getFleetOptions()}
            value={{
              value: selectedFleets,
              label: getFleetOptions()?.find(
                (fleet) => fleet.value === selectedFleets
              )?.label,
              fleetCode: getFleetOptions()?.find(
                (fleet) => fleet.value === selectedFleets
              )?.fleetCode,
            }}
            onChange={(value) => {
              // const allValues = value?.map((item) => item.value);
              // // console.log({value})

              // if (allValues.includes("all")) {
              //   // console.log("first");

              //   setSelectedFleets(
              //     allFleets?.data?.map((item) => {
              //       return item._id;
              //     })
              //   );
              // } else {
              setSelectedFleets(value.value);
              setSelectedFleetCodes(value.fleetCode);
              // }
            }}
            name="fleets"
            isMulti={false}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Select Hub
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getHubOptions()}
            placeholder="All"
            value={{
              value: selectedHubs,
              label: getHubOptions()?.find((hub) => hub.value === selectedHubs)
                ?.label,
            }}
            onChange={(value) => {
              // setCheck(true)
              // // console.log({value})
              setSelectedHubs(value.value);
            }}
            name="hub"
            isMulti={false}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Select Service Type
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={contractTypes}
            value={contractTypes.find((fleetType) => {
              return fleetType.value === contractType;
            })}
            onChange={(value) => {
              setContractType(value.value);
              if (value.value == "NON CPKM") {
                setSelectedCPKMProducts([]);
                setSelectedProducts(
                  selectedProducts?.filter((item) => item.type !== "CPKM")
                );
              }
              if (value.value == "CPKM") {
                setSelectedProducts([]);
                setSelectedCPKMProducts(
                  selectedProducts?.filter((item) => item.type === "CPKM")
                );
              }
            }}
            name="contractType"
            isMulti={false}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Select Patterns
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            // options={(()=>{
            //   console.log(getProductOptions());
            // return getProductOptions()})()}
            options={getProductOptions()}
            placeholder="All"
            value={
              selectedProducts &&
              selectedProducts?.map((product) => {
                // // console.log({product})
                return {
                  value: product.value,
                  label: getProductOptions()
                    ?.filter((item) => item.value !== "all")
                    ?.find((item) => item.value === product.value)?.label,
                  meta: getProductOptions()
                    ?.filter((item) => item.value !== "all")
                    ?.find((item) => item.value === product.value)?.meta,
                  type: getProductOptions()
                    ?.filter((item) => item.value !== "all")
                    ?.find((item) => item.value === product.value)?.type,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              // console.log({value})
              // console.log({selectedProducts, selectedCPKMProducts})

              // Array.from(new Set(data.flatMap(obj => obj.subs)))

              if (allValues.includes("all")) {
                setSelectedProducts(
                  getProductOptions()?.filter((item) => item.value !== "all")
                );
                setSelectedCPKMProducts(
                  getProductOptions()
                    ?.filter((item) => item.value !== "all")
                    ?.filter((item) => item.type === "CPKM")
                );
              } else {
                setSelectedProducts(value);
                setSelectedCPKMProducts(
                  value.filter((product) => product.type === "CPKM")
                );
              }
            }}
            name="patterns"
            isMulti={true}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Select Sizes
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getSizeOptions()}
            placeholder="All"
            value={
              selectedSizes &&
              selectedSizes?.map((size) => {
                return {
                  value: size,
                  label: size,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);

              if (allValues.includes("all")) {
                setSelectedSizes(
                  getSizeOptions()
                    ?.filter((item) => item.value !== "all")
                    ?.map((item) => {
                      return item.value;
                    })
                );
                setSelectedCPKMSizes(
                  getSizeOptions()
                    ?.filter((item) => item.value !== "all")
                    ?.filter((item) => item.type === "CPKM")
                    ?.map((item) => {
                      return item.value;
                    })
                );
              } else {
                // let selectedSizesVal = allSizes?.data?.filter((fleet) =>
                //   value?.map((item) => item.value)?.includes(fleet._id)
                // );

                setSelectedSizes(value.map((make) => make.value));
                setSelectedCPKMSizes(
                  value
                    .filter((product) => product.type === "CPKM")
                    .map((product) => product.value)
                );
              }
            }}
            name="fleets"
            isMulti={true}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Select Configurations
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getConfigurationOptionss()}
            placeholder="All"
            value={
              selectedConfigurations &&
              selectedConfigurations?.map((configuration) => {
                return {
                  value: configuration,
                  label:
                    allConfigurations?.data?.find(
                      (item) => item._id === configuration
                    )?.make?.makeName +
                    "/" +
                    allConfigurations?.data?.find(
                      (item) => item._id === configuration
                    )?.model?.name +
                    "/" +
                    allConfigurations?.data?.find(
                      (item) => item._id === configuration
                    )?.name,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);

              if (allValues.includes("all")) {
                setSelectedConfigurations(
                  allConfigurations?.data?.map((item) => {
                    return item._id;
                  })
                );
              } else {
                let selectedConfigurationsVal = allConfigurations?.data?.filter(
                  (fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                );

                setSelectedConfigurations(value.map((make) => make.value));
              }
            }}
            name="fleets"
            isMulti={true}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Start Date{" "}
          <Input
            type="date"
            max={getFormattedDate()}
            name="dateFrom"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </label>
        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          End Date{" "}
          <Input
            type="date"
            min={getFormattedDate(dateFrom)}
            name="dateTo"
            value={dateTo}
            max={getFormattedDate()}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </label>

        <label className="w-full py-3 col-span-2 md:col-span-1 flex flex-col gap-2">
          Percentage Wear
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={wearOptions}
            placeholder="All"
            value={wearOptions.find(option => option.value === selectedWearPercent)}
            onChange={(value) => setSelectedWearPercent(value.value)}
            name="wearPercent"
            isMulti={false}
          />
        </label>

        <button
          type="button"
          disabled={
            loadingFleets ||
            !selectedFleets.length ||
            !getFleetOptions()?.length ||
            !getHubOptions()?.length
          }
          className={`h-10 px-4 bg-green-500 text-white rounded-lg mb-3 w-24 ${(loadingFleets ||
              !selectedFleets.length ||
              !getFleetOptions()?.length ||
              !getHubOptions()?.length) &&
            "bg-gray-400"
            } col-span-1`}
          bgPrimary
          onClick={() => {
            clickSearchBtn();
            setFetch((st) => st + 1);
            getDashboardSummary();
          }}
        >
          Search
        </button>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        summary && (
          <div className="w-full px-8 flex flex-row grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 justify-center items-center gap-4 mb-4 ">
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              {/* cpkm */}
              <div className="font-normal text-black">Tyres Supplied </div>
              <div className="font-medium text-sky-600 inter">
                {summary.tyresCount}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Vehicle Count </div>
              <div className="font-medium text-sky-600 inter">
                {summary.vehiclesCount}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Wheel Count </div>
              <div className="font-medium text-sky-600 inter">
                {summary.wheelsCount}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              {/* cpkm */}
              <div className="font-normal text-black">CPKM Wheels </div>
              <div className="font-medium text-sky-600 inter">
                {summary.cpkmWheelsCount ?? 0}{" "}
              </div>
            </div>
           {checkPermission([permissions.view_agreed_cpkm_dashboard], currentUser) && <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Agreed CPKM </div>
              <div className="font-medium text-sky-600 inter">
                {checkPermission([permissions.view_agreed_cpkm_dashboard], currentUser) && 
                parseFloat(summary.agreedCPKM)}{" "}
              </div>
            </div>}
           {checkPermission([permissions.view_actual_cpkm_dashboard], currentUser) && <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Actual CPKM </div>
              <div className="font-medium text-sky-600 inter">
                {checkPermission([permissions.view_actual_cpkm_dashboard], currentUser) && parseFloat(summary.actualCPKM).toFixed(3)}{" "}
              </div>
            </div>}
          </div>
        )
      )}
      {fetch ? (
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 p-2">
          <div className="col-span-1 flex h-full w-full">
            <StockDetailsSummary
              selectedFleets={selectedFleets}
              selectedConfigurations={selectedConfigurations}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
              selectedHubs={selectedHubs}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedProducts={selectedProducts}
              selectedSizes={selectedSizes}
              selectedCPKMProducts={selectedCPKMProducts}
              selectedCPKMSizes={selectedCPKMSizes}
              getFleetOptions={getFleetOptions}
              getHubOptions={getHubOptions}

            />
          </div>
          <div className="col-span-1 flex h-full w-full">
            <NSDDistributionChart
              selectedFleets={selectedFleets}
              selectedConfigurations={selectedConfigurations}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
              selectedHubs={selectedHubs}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedProducts={selectedProducts}
              selectedSizes={selectedSizes}
              selectedCPKMProducts={selectedCPKMProducts}
              selectedCPKMSizes={selectedCPKMSizes}
              getFleetOptions={getFleetOptions}
              getHubOptions={getHubOptions}
            />
          </div>
          <div className="col-span-1 flex h-full w-full">
            <ScrapAnalysis
              selectedFleets={selectedFleets}
              selectedConfigurations={selectedConfigurations}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
              selectedHubs={selectedHubs}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedProducts={selectedProducts}
              selectedSizes={selectedSizes}
              selectedCPKMProducts={selectedCPKMProducts}
              selectedCPKMSizes={selectedCPKMSizes}
              getFleetOptions={getFleetOptions}
              getHubOptions={getHubOptions}
            />
          </div>
          <div className="col-span-1 flex h-full w-full">
            <FittedTyreAnalysis
              selectedFleets={selectedFleets}
              selectedConfigurations={selectedConfigurations}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
              selectedHubs={selectedHubs}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedProducts={selectedProducts}
              selectedSizes={selectedSizes}
              selectedCPKMProducts={selectedCPKMProducts}
              selectedCPKMSizes={selectedCPKMSizes}
              getFleetOptions={getFleetOptions}
              getHubOptions={getHubOptions}
              selectedWearPercent={selectedWearPercent}
            />
          </div>
          <div className="col-span-1 flex h-full w-full">
            <MilageAnalysis
              selectedFleets={selectedFleets}
              selectedConfigurations={selectedConfigurations}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
              selectedHubs={selectedHubs}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedProducts={selectedProducts}
              selectedSizes={selectedSizes}
              selectedCPKMProducts={selectedCPKMProducts}
              selectedCPKMSizes={selectedCPKMSizes}
              getFleetOptions={getFleetOptions}
              getHubOptions={getHubOptions}
              selectedWearPercent={selectedWearPercent}
            />
          </div>
          <div className="col-span-1 flex h-full w-full">
            <ZoneChart
              agreedCPKM={summary?.agreedCPKM}
              actualCPKM={parseInt(summary?.actualCPKM * 1000) / 1000}
              isLoading={isLoading}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

{modalData !== null && (
  <ModalTable
    modalData={modalData}
    setModalData={setModalData}
    exportExcel={exportExcel}
  />
)}
      
    </div>
  );
};

const COLORS = ["#FF0000", "#FA8128", "#1CE369", "#2AE3D7", "#DC59EE", "#EED311", "#00BFFF", "#EF3710", "#FA8128", "#933", "#1B77E4", "#E4881B", "#3CC39F", "#C33C60", "#ABBB44", "#5444BB", "#1AE563", "#C314EB", "#E51A9C", "#E5C91A", "#35A0CA", "#AA35CA", "#CA5F35", "#55CA35"];
const BARCHARTCOLORS = ["#00CED1", "#1CE369", "#FA8128", "#FF0000"]
const STOCK_BAR_THICKNESS = 27;
const indexOf = {
  "ITM": 0,
  "RTD": 1,
  "SRP": 2,
  "SOLD": 3
}

const transformDataForExcel = (data, isMilageAnalysis = false) => {
  if (!Array.isArray(data) || data.length === 0) return data;
  
  // First pass: Check if RTD2 or RTD3 have any values greater than 0
  const hasRtd2 = data.some(item => (item.RTD2 || 0) > 0);
  const hasRtd3 = data.some(item => (item.RTD3 || 0) > 0);
  
  return data.map((item) => {
    const transformedItem = { ...item };
    const isSold = item.soldOut === true;
    
    // Get ITM and RTD kilometers from the item
    const itmKm = item.ITM || 0;
    const rtd1Km = item.RTD1 || 0;
    const rtd2Km = item.RTD2 || 0;
    const rtd3Km = item.RTD3 || 0;
    
    const keys = Object.keys(transformedItem);
    const tyreTypeIndex = keys.indexOf("tyreType");
    const percentageWearIndex = keys.indexOf("Percentage Wear");
    const totalKmIndex = keys.indexOf("totalKillometerTravelled");
    const projectionKmIndex = keys.indexOf("projectionKm");
    
    const newItem = {};
    
    keys.slice(0, tyreTypeIndex + 1).forEach(key => {
      newItem[key] = transformedItem[key];
    });
    
    if (isSold) {
      const tyreType = item.soldTyreType || item.tyreType || "ITM";
      newItem["soldTyreType"] = tyreType;
    } else {
      newItem["soldTyreType"] = "";
    }
    
    // Add ITM and RTD1 kilometers (always show these)
    newItem["ITM km"] = itmKm;
    newItem["RTD1 km"] = rtd1Km;
    
    // Only add RTD2 and RTD3 if they exist and are greater than 0 in at least one row
    if (hasRtd2) {
      newItem["RTD2 km"] = rtd2Km;
    }
    if (hasRtd3) {
      newItem["RTD3 km"] = rtd3Km;
    }
    
    // Fields to exclude (we've already added them with "km" suffix)
    const excludeFields = ["soldOut", "ITM", "RTD1", "RTD2", "RTD3"];
    
    if (isMilageAnalysis && percentageWearIndex !== -1 && totalKmIndex !== -1) {
      keys.slice(tyreTypeIndex + 1, percentageWearIndex + 1).forEach(key => {
        if (!excludeFields.includes(key)) {
          newItem[key] = transformedItem[key];
        }
      });
      
      newItem["totalKillometerTravelled"] = transformedItem["totalKillometerTravelled"];
      
      if (projectionKmIndex !== -1) {
        newItem["projectionKm"] = transformedItem["projectionKm"];
      }
      
      keys.slice(totalKmIndex + 1).forEach(key => {
        if (!excludeFields.includes(key) && key !== "totalKillometerTravelled" && key !== "projectionKm") {
          newItem[key] = transformedItem[key];
        }
      });
    } else {
      keys.slice(tyreTypeIndex + 1).forEach(key => {
        if (!excludeFields.includes(key)) {
          newItem[key] = transformedItem[key];
        }
      });
    }
    
    return newItem;
  });
};
const StockDetailsSummary = ({ selectedFleets, selectedConfigurations, contractType, fetch, setModalData, selectedHubs, selectedProducts, selectedSizes, dateFrom, dateTo, selectedCPKMProducts, selectedCPKMSizes, getFleetOptions, getHubOptions }) => {
  // Your hub data
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const chartRef = useRef();
  const getChartData = async () => {
    setIsLoading(true);
    try {
      const dt = await createDocument("/dashboard/mobility/stock-details", {
        ...(selectedFleets !== "all" ? {
          fleets: selectedFleets
        } : { fleets: getFleetOptions()?.filter(data => data.value!== "all")?.map(data => { return data.value }).join(",") }),
        ...(selectedHubs !== "all" ? {
          hubs: selectedHubs
        } : { hubs: getHubOptions()?.filter(data => data.value!== "all")?.map(data => { return data.value }).join(",") }),
        ...(selectedConfigurations.length && {
          makes: selectedConfigurations.map((make) => make).join(","),
        }),
        ...(selectedCPKMProducts.length && {
          cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(","),
        }),
        ...(selectedProducts.length && {
          products: selectedProducts.filter(item => item.type === "NON CPKM")?.flatMap((make) => make.meta.ids).join(","),
        }),
        ...(selectedSizes.length && {
          tyreSize: selectedSizes.map((make) => make).join(","),
        }),
        ...(contractType && { contractType }),
        ...dateFrom && { dateFrom },
        ...dateTo && { dateTo }
      });
      const labels = [
        "New",
        "Reusable",
        "Cut Repair",
        "In Transit",
        "Casings",
        "OnWheel",
        "Scrap",
        "Missing",
        "Retread",
        "Sold Out",
      ];

      const ensureArray = (value) => (Array.isArray(value) ? value : []);

      const orderedData = [...dt.data].sort((a, b) => {
        const order = ["ITM", "RTD", "SRP", "SOLD"];
        return (
          order.indexOf(a._id.tyreTypeCategory) -
          order.indexOf(b._id.tyreTypeCategory)
        );
      });

      const datasets = orderedData
        .map((item) => {
          const type = item._id.tyreTypeCategory;
          // Skip SOLD category - it will be handled separately
          if (indexOf[type] === undefined || type === "SOLD") {
            return null;
          }

          const color = BARCHARTCOLORS[indexOf[type]];
          // Explicitly set all positions, ensuring Sold Out (position 9) is always 0
          const data = [
            item.newLength ?? 0,
            item.reuseLength ?? 0,
            item.repairLength ?? 0,
            item.inTransitLength ?? 0,
            item.casingLength ?? 0,
            item.fittedLength ?? 0,
            item.scrapLength ?? 0,
            item.missingLength ?? 0,
            item.retreadLength ?? 0,
            0, // Sold Out - explicitly 0, will be handled by separate sold dataset
          ];

          return {
            label: type,
            backgroundColor: color,
            borderWidth: 1,
            borderRadius: 3,
            hoverBackgroundColor: color,
            hoverBorderColor: color,
            minBarLength: "20",
            barThickness: STOCK_BAR_THICKNESS,
            maxBarThickness: STOCK_BAR_THICKNESS,
            data,
            tyreTypeCategory: type,
          };
        })
        .filter(Boolean);

      const soldCategory = orderedData.find(item => item._id.tyreTypeCategory === "SOLD");
      
      if (soldCategory && soldCategory.soldLength > 0) {
        const soldData = new Array(10).fill(0);
        
        soldData[9] = soldCategory.soldLength ?? 0;
        // Add sold dataset at the end so it renders on top (red only, no green)

        console.log('soldData--',soldData);
        datasets.push({
          label: "SOLD",
          backgroundColor: "#FF0000", // Red for all sold tyres
          borderWidth: 1,
          borderRadius: 3,
          hoverBackgroundColor: "#FF0000",
          hoverBorderColor: "#FF0000",
          minBarLength: "20",
          barThickness: STOCK_BAR_THICKNESS,
          maxBarThickness: STOCK_BAR_THICKNESS,
          data: soldData,
          tyreTypeCategory: "SOLD",
        });
      }

      setchartData({
        labels,
        datasets,
      });
    } catch (err) {
      setchartData(null)
    }
    setIsLoading(false);
  };

  useMemo(() => {
    if (fetch) getChartData()
  }, [fetch])

  // console.log(chartData)

  return (
    <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "600px" }} className="w-full h-full items-center text-center">
      {isLoading ? <Loading></Loading> : chartData &&
        <div style={{ height: '100%', width: '100%', minHeight: '400px' }}>
          {/* <div className = "text-gray-500 inter font-bold text-[14px] text-center mx-auto"> Scrap Analysis</div> */}
          <ResponsiveContainer width="95%" height={450}>
            <Bar
              data={chartData}
              ref={chartRef}
              labels={false}
              onClick={async (event) => {
                     const chart = chartRef.current;
                if (!chart) return;
                const nativeEvent = event.nativeEvent || event;

                let hit = chart.getElementsAtEventForMode(nativeEvent, 'nearest', { intersect: true }, false);

                // Fallback: tiny stacked segments (e.g. RTD on a log-scaled stack with
                // minBarLength) render visually larger than their computed hitbox, so
                // strict intersect misses. Resolve by checking all bars in the clicked
                // column and picking the segment whose Y range contains the click.
                if (!hit || hit.length === 0) {
                  const stack = chart.getElementsAtEventForMode(nativeEvent, 'index', { intersect: false, axis: 'x' }, false) || [];
                  const yClick = nativeEvent.offsetY;
                  hit = stack.filter(({ datasetIndex, index }) => {
                    const value = chartData.datasets?.[datasetIndex]?.data?.[index] || 0;
                    if (value === 0) return false;
                    const bar = chart.getDatasetMeta(datasetIndex)?.data?.[index];
                    if (!bar) return false;
                    const top = Math.min(bar.y, bar.base);
                    const bottom = Math.max(bar.y, bar.base);
                    return yClick >= top && yClick <= bottom;
                  });
                }

                const datasetIndex = hit?.[0]?.datasetIndex;
                const eleIndex = hit?.[0]?.index;
                if (!chartData?.datasets?.[datasetIndex]?.data?.[eleIndex] || chartData.datasets[datasetIndex].data[eleIndex] === 0) {
                  return;
                }
                
                const tyreTypeCategory = chartData.datasets[datasetIndex].tyreTypeCategory;
                const statusLabels = [
                  "New",
                  "Reusable",
                  "Cut Repair",
                  "In Transit",
                  "Casings",
                  "OnWheel",
                  "Scrap",
                  "Missing",
                  "Retread",
                  "Sold Out",
                ];
                const status = statusLabels[eleIndex];
                
                try {
                  const modalResponse = await createDocument("/dashboard/mobility/stock-details/modalInfo", {
                    ...(selectedFleets !== "all" ? {
                      fleets: selectedFleets
                    } : { fleets: getFleetOptions()?.filter(data => data.value!== "all")?.map(data => { return data.value }).join(",") }),
                    ...(selectedHubs !== "all" ? {
                      hubs: selectedHubs
                    } : { hubs: getHubOptions()?.filter(data => data.value!== "all")?.map(data => { return data.value }).join(",") }),
                    ...(selectedConfigurations.length && {
                      makes: selectedConfigurations.map((make) => make).join(","),
                    }),
                    ...(selectedCPKMProducts.length && {
                      cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(","),
                    }),
                    ...(selectedProducts.length && {
                      products: selectedProducts.filter(item => item.type === "NON CPKM")?.flatMap((make) => make.meta.ids).join(","),
                    }),
                    ...(selectedSizes.length && {
                      tyreSize: selectedSizes.map((make) => make).join(","),
                    }),
                    ...(contractType && { contractType }),
                    ...dateFrom && { dateFrom },
                    ...dateTo && { dateTo },
                    tyreTypeCategory,
                    status,
                  });
                  
                  const transformedData = transformDataForExcel(modalResponse.data || [], false);
                  setModalData({
                    title: "Stock Details",
                    data: transformedData
                  });
                } catch (err) {
                  console.error("Error fetching modal data:", err);
                }
              }}
              options={{
                maintainAspectRatio: false, // Set this to false to allow the chart to take the full height of its container
                responsive: true,
                indexAxis: 'y',
                scales: {
                  x: {
                    grid: {
                      display: true
                    },
                    ticks: {
                      font: {
                        family: 'Inter', // Your font family
                        size: 14,
                      },
                    },
                    stacked: true,
                    // type: "logarithmic"
                  },
                  y: {
                    grid: {
                      display: false,
                    },
                    ticks: {
                      stepSize: 50,
                      font: {
                        family: 'Inter', // Your font family
                        size: 14,
                      },
                    },
                    minBarLength: 100,
                    stacked: true,
                    type: "logarithmic",
                  },
                },

                indexAxis: 'x',
                // Room for the value label that sits on top of the tallest /
                // right-most bar, which used to be clipped by the plot edge.
                layout: {
                  padding: { top: 16, right: 16, left: 4 },
                },
                plugins: {
                  datalabels: {
                    // 'auto' is not a valid anchor/align value - it silently fell
                    // back to centre, so 6-digit labels on 27px bars ran into the
                    // neighbouring bar's label. A smaller font fits inside one bar
                    // slot, and display:'auto' drops any label that still collides.
                    anchor: 'center',
                    align: 'center',
                    clamp: true,
                    display: 'auto',
                    color: "black", // Set the color of the values
                    font: {
                      family: 'Inter', // Your font family
                      size: 10,
                      weight: 600,
                    },
                    formatter: (value, context) => {
                      // // console.log({context})
                      return value ? value : ""
                    },


                  },
                  title: {
                    display: true,
                    text: "Stock Details",
                    font: {
                      size: 14,
                      family: "Inter"
                    }
                  },
                  legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                      filter: (legendItem) => {
                        // Hide datasets with empty or undefined labels
                        return legendItem.text && legendItem.text.trim() !== '';
                      },
                      font: {
                        size: window.innerWidth < 768 ? 8 : 14,
                        family: "Inter"
                      },
                      boxWidth: window.innerWidth < 768 ? 8 : 12,
                      boxHeight: window.innerWidth < 768 ? 8 : 12,
                      padding: window.innerWidth < 768 ? 6 : 8,
                      usePointStyle: false,
                      pointStyle:'circle'
                    }
                  }
                }
              }}
              plugins={[ChartDataLabels]} // Include the datalabels plugin

            />
          </ResponsiveContainer>
        </div>
      }
    </Box>
  );
};

const FittedTyreAnalysis = ({
  selectedFleets,
  selectedConfigurations,
  contractType,
  fetch,
  setModalData,
  selectedHubs,
  selectedProducts,
  selectedSizes,
  dateFrom,
  dateTo,
  selectedCPKMProducts,
  selectedCPKMSizes,
  getHubOptions,
  getFleetOptions,
  selectedWearPercent
}) => {
  const [data, setData] = useState(null);
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [strikethroughLabels, setStrikethroughLabels] = useState([]);
  const chartRef = useRef();

  const getModalFilters = useCallback(() => ({
    ...(selectedFleets !== "all"
      ? { fleets: selectedFleets }
      : { fleets: getFleetOptions()?.filter(d => d.value !== "all")?.map(d => d.value).join(",") }),
    ...(selectedHubs !== "all"
      ? { hubs: selectedHubs }
      : { hubs: getHubOptions()?.filter(d => d.value !== "all")?.map(d => d.value).join(",") }),
    ...(selectedConfigurations?.length && {
      configurations: selectedConfigurations.map((m) => m).join(","),
    }),
    ...(selectedCPKMProducts?.length && {
      cpkmproducts: selectedCPKMProducts.flatMap((m) => m.meta.ids).join(","),
    }),
    ...(selectedProducts?.length && {
      products: selectedProducts.filter(p => p.type === "NON CPKM")?.flatMap((m) => m.meta.ids).join(","),
    }),
    ...(selectedSizes?.length && { tyreSize: selectedSizes.map((m) => m).join(",") }),
    ...(contractType && { contractType }),
    ...(dateFrom && { dateFrom }),
    ...(dateTo && { dateTo }),
    ...(selectedWearPercent && { percentageWear: selectedWearPercent }),
  }), [
    selectedFleets,
    selectedHubs,
    selectedConfigurations,
    selectedCPKMProducts,
    selectedProducts,
    selectedSizes,
    contractType,
    dateFrom,
    dateTo,
    selectedWearPercent,
    getFleetOptions,
    getHubOptions,
  ]);

  const getChartData = async () => {
    setIsLoading(true);
    try {
      const dt = await createDocument("/dashboard/mobility/fitted-tyre-analysis", {
        ...getModalFilters(),
        ...(selectedConfigurations?.length && {
          makes: selectedConfigurations.map((m) => m).join(","),
        }),
      });

      const totalCounts = dt.totalCounts ?? [];
      const analysisData = dt.data ?? [];

      setchartData({
        labels: totalCounts.map(count => count._id),
        datasets: analysisData.map((item) => {
          const tyreSizes = item.tyreSizes ?? [];
          return {
            label: item._id,
            backgroundColor: BARCHARTCOLORS[indexOf[item._id]],
            borderWidth: 1,
            borderRadius: 3,
            hoverBackgroundColor: BARCHARTCOLORS[indexOf[item._id]],
            hoverBorderColor: BARCHARTCOLORS[indexOf[item._id]],
            data: totalCounts.map(totalCount => {
              const found = tyreSizes.find(t => t.tyreSize === totalCount._id);
              const count = found?.count ?? 0;
              const denom = totalCount.count ?? 1;
              return parseFloat(((count / denom) * 100).toFixed(1));
            }),
            values: totalCounts.map(totalCount => {
              const found = tyreSizes.find(t => t.tyreSize === totalCount._id);
              return found?.count ?? 0;
            }),
            db: totalCounts.map(totalCount => {
              const found = tyreSizes.find(t => t.tyreSize === totalCount._id);
              return found ? [found] : [{ data: "NO DATA AVAILABLE FOR " + totalCount._id }];
            }),
            averageOriginalNSD: totalCounts.map(totalCount => {
              const d = item?.averageOriginalNSD?.find(t => t?.tyreSize === totalCount._id);
              return d?.averageOriginalNSD ?? "N/A";
            }),
            averageNSD: totalCounts.map(totalCount => {
              const d = item?.averageNSD?.find(t => t?.tyreSize === totalCount._id);
              return d?.averageNSD ?? "N/A";
            }),
            averagePercentageWear: totalCounts.map(totalCount => {
              const d = item?.averagePercentageWear?.find(t => t?.tyreSize === totalCount._id);
              return d?.averagePercentageWear ?? "N/A";
            }),
            averageTotalKillometerTravelled: totalCounts.map(totalCount => {
              const d = item?.averageTotalKillometerTravelled?.find(t => t?.tyreSize === totalCount._id);
              return d?.averageTotalKillometerTravelled ?? "N/A";
            }),
            averageMilage: totalCounts.map(totalCount => {
              const d = item?.averageMilage?.find(t => t?.tyreSize === totalCount._id);
              return d?.averageMilage ?? "N/A";
            }),
          };
        }),
      });
    } catch (err) {
      setchartData(null);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (fetch) getChartData();
  }, [fetch]);

  return (
    <Box
      sx={{
        p: 2,
        boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)",
        borderRadius: 2,
        backgroundColor: "#f8fafc",
        maxHeight: "700px",
      }}
      className="w-full h-full items-center text-center"
    >
      {isLoading ? (
        <Loading />
      ) : (
        chartData && (
          <div style={{ height: "100%", width: "100%", position: "relative" }}>
            {modalLoading && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255,255,255,0.7)",
                  zIndex: 10,
                }}
              >
                <Loading />
              </div>
            )}
            <ResponsiveContainer width="90%" height={500}>
              <Bar
                data={chartData}
                ref={chartRef}
                onClick={async (event) => {
                  const elements = getElementAtEvent(chartRef.current, event);
                  const datasets = getDatasetAtEvent(chartRef.current, event);
                  if (!elements?.length || !datasets?.length) return;

                  const datasetIndex = datasets[0].datasetIndex;
                  const eleIndex = elements[0]?.index;
                  if (eleIndex == null) return;

                  const value = chartData.datasets[datasetIndex].values?.[eleIndex];
                  if (!value || value === 0) return;

                  const tyreTypeCategory = chartData.datasets[datasetIndex].label;
                  const clickedTyreSize = chartData.labels[eleIndex];

                  setModalLoading(true);
                  try {
                    const modalResponse = await createDocument("/dashboard/mobility/fitted-tyre-analysis/modalInfo", {
                      ...getModalFilters(),
                      tyreTypeCategory,
                      clickedTyreSize,
                    });
                    const raw = modalResponse?.data ?? [];
                    const transformedData = transformDataForExcel(raw, false);

                    const n = raw.length;
                    const sum = (key) => raw.reduce((a, r) => a + (Number(r[key]) || 0), 0);
                    const avg = (key) => (n ? (sum(key) / n).toFixed(2) : "N/A");

                    setModalData({
                      title: "Fitted Tyre Analysis - CPKM",
                      data: transformedData,
                      footer: [
                        { title: "Avg Original NSD", value: avg("Original NSD") },
                        { title: "Avg NSD", value: avg("averageNSD") },
                        { title: "Avg Percentage Wear", value: avg("Percentage Wear") },
                        { title: "Avg TotalKm", value: avg("totalKillometerTravelled") },
                        { title: "Avg Projection KM", value: avg("projectionKm") },
                      ],
                    });
                  } catch (err) {
                    setModalData({
                      title: "Fitted Tyre Analysis - CPKM",
                      data: [],
                      footer: [],
                    });
                  } finally {
                    setModalLoading(false);
                  }
                }}
                options={{
                  barThickness: 30,
                  maintainAspectRatio: false,
                  responsive: true,
                  indexAxis: "y",
                  scales: {
                    x: {
                      grid: {
                        display: true,
                      },
                      bounds: 'data',
                      ticks: {
                        font: {
                          family: "Inter",
                          size: 14,
                        },
                      },
                      stacked: true,
                      position: "bottom",
                    },
                    y: {
                      grid: {
                        display: false,
                      },
                      ticks: {
                        stepSize: 10,
                        font: {
                          family: "Inter",
                          size: 14,
                        },
                      },
                      stacked: true,
                    },
                  },
                  plugins: {
                    datalabels: {
                      anchor: "auto",
                      align: "auto",
                      display: true,
                      color: "black",
                      font: {
                        family: "Inter",
                        size: 14,
                      },
                      formatter: (value, context) => {
                        const { datasetIndex, dataIndex: eleIndex } = context;
                        const data = parseInt(chartData.datasets[datasetIndex].values[eleIndex]);
                        return `${data ? data + "" : ""}`;
                      },
                    },
                    title: {
                      display: true,
                      text: "Fitted Tyre Analysis - CPKM",
                      font: {
                        size: 14,
                        family: "Inter",
                      },
                    },
                    legend: {
                      display: true,
                      position: "bottom",
                      labels: {
                        font: {
                          size: 14,
                          family: "Inter",
                        },
                      },
                    },
                    tooltip: {
                      callbacks: {
                        label: (tooltipItem) => {
                          let label = chartData.datasets[tooltipItem.dataIndex]?.label || '';
                          if (label) label += ': ';
                          const value = chartData.datasets[tooltipItem.datasetIndex]?.data[tooltipItem.dataIndex];
                          const avgMilage = chartData.datasets[tooltipItem.datasetIndex]?.averageMilage[tooltipItem.dataIndex];
                          label += `${value}% (Average Milage: ${avgMilage})`;
                          return label;
                        },
                        labelColor: () => ({
                          borderColor: 'rgb(0, 0, 255)',
                          backgroundColor: 'rgb(255, 0, 0)',
                          borderWidth: 2,
                          borderDash: [2, 2],
                          borderRadius: 2,
                        }),
                        labelTextColor: () => 'white',
                      }
                    }
                  }
                }}
                plugins={[ChartDataLabels]}
              />
            </ResponsiveContainer>
          </div>
        )
      )}
    </Box>
  );
};


const MilageAnalysis = ({ selectedFleets, selectedConfigurations, contractType, fetch, setModalData, selectedHubs, selectedProducts, selectedSizes, dateFrom, dateTo, selectedCPKMProducts, selectedCPKMSizes,
  getHubOptions,
  getFleetOptions,
  selectedWearPercent
}) => {
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const chartRef = useRef();
  const [strikethroughLabels, setStrikethroughLabels] = useState([]);

  const getModalFilters = useCallback(() => ({
    ...(selectedFleets !== "all" ? { fleets: selectedFleets } : { fleets: getFleetOptions()?.filter(d => d.value !== "all")?.map(d => d.value).join(",") }),
    ...(selectedHubs !== "all" ? { hubs: selectedHubs } : { hubs: getHubOptions()?.filter(d => d.value !== "all")?.map(d => d.value).join(",") }),
    ...(selectedConfigurations?.length && { configurations: selectedConfigurations.map(m => m).join(",") }),
    ...(selectedCPKMProducts?.length && { cpkmproducts: selectedCPKMProducts.flatMap(m => m.meta.ids).join(",") }),
    ...(selectedProducts?.length && { products: selectedProducts.filter(p => p.type === "NON CPKM").flatMap(m => m.meta.ids).join(",") }),
    ...(selectedSizes?.length && { tyreSize: selectedSizes.map(m => m).join(",") }),
    ...(contractType && { contractType }),
    ...(dateFrom && { dateFrom }),
    ...(dateTo && { dateTo }),
    ...(selectedWearPercent && { percentageWear: selectedWearPercent }),
  }), [selectedFleets, selectedHubs, selectedConfigurations, selectedCPKMProducts, selectedProducts, selectedSizes, contractType, dateFrom, dateTo, selectedWearPercent, getFleetOptions, getHubOptions]);

  const getChartData = async () => {
    setIsLoading(true);
    try {
      const dt = await createDocument("/dashboard/mobility/milage-analysis", {
        ...getModalFilters(),
        ...(selectedConfigurations?.length && { makes: selectedConfigurations.map(m => m).join(",") }),
      });

      const totalCounts = dt.totalCounts ?? [];
      const analysisData = dt.data ?? [];

      setchartData({
        labels: totalCounts.map(c => c._id),
        datasets: analysisData.map((item) => {
          const tyreSizes = item.tyreSizes ?? [];
          return {
            label: item._id,
            backgroundColor: BARCHARTCOLORS[indexOf[item._id]],
            borderWidth: 1,
            borderRadius: 3,
            hoverBackgroundColor: BARCHARTCOLORS[indexOf[item._id]],
            hoverBorderColor: BARCHARTCOLORS[indexOf[item._id]],
            data: totalCounts.map(tc => {
              const found = tyreSizes.find(t => t.tyreSize === tc._id);
              const count = found?.count ?? 0;
              const denom = tc.count ?? 1;
              return parseFloat(((count / denom) * 100).toFixed(1));
            }),
            values: totalCounts.map(tc => {
              const found = tyreSizes.find(t => t.tyreSize === tc._id);
              if (!found?.count) return 0;
              const avg = found.averageMilage ?? 0;
              return typeof avg === "number" ? Math.round(avg) : parseInt(avg, 10) || 0;
            }),
            averageMilage: totalCounts.map(tc => {
              const d = tyreSizes.find(t => t.tyreSize === tc._id);
              return d?.averageMilage ?? "N/A";
            }),
            averageNSD: totalCounts.map(tc => {
              const d = tyreSizes.find(t => t.tyreSize === tc._id);
              return d?.averageNSD ?? "N/A";
            }),
            averageTotalKillometerTravelled: totalCounts.map(tc => {
              const d = tyreSizes.find(t => t.tyreSize === tc._id);
              return d?.averageTotalKillometerTravelled ?? "N/A";
            }),
            averagePercentageWear: totalCounts.map(tc => {
              const d = tyreSizes.find(t => t.tyreSize === tc._id);
              return d?.averagePercentageWear ?? "N/A";
            }),
            averageOriginalNSD: totalCounts.map(tc => {
              const d = tyreSizes.find(t => t.tyreSize === tc._id);
              return d?.averageOriginalNSD ?? "N/A";
            }),
          };
        }),
      });
    } catch (err) {
      setchartData(null);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (fetch) {
      getChartData();
      setStrikethroughLabels([]);
    }
  }, [fetch]);

  return (
    <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "700px" }} className="w-full h-full items-center text-center">
      {isLoading ? <Loading /> : chartData && (
        <div style={{ height: "100%", width: "100%", position: "relative" }}>
          {modalLoading && (
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.7)", zIndex: 10 }}>
              <Loading />
            </div>
          )}
          <ResponsiveContainer width="90%" height={500}>
            <Bar
              data={chartData}
              ref={chartRef}
              onClick={async (event) => {
                const elements = getElementAtEvent(chartRef.current, event);
                const datasets = getDatasetAtEvent(chartRef.current, event);
                if (!elements?.length || !datasets?.length) return;

                const datasetIndex = datasets[0].datasetIndex;
                const eleIndex = elements[0]?.index;
                if (eleIndex == null) return;

                const value = chartData.datasets[datasetIndex].values?.[eleIndex];
                if (!value || value === 0) return;

                const tyreTypeCategory = chartData.datasets[datasetIndex].label;
                const clickedTyreSize = chartData.labels[eleIndex];

                setModalLoading(true);
                try {
                  const modalResponse = await createDocument("/dashboard/mobility/milage-analysis/modalInfo", {
                    ...getModalFilters(),
                    tyreTypeCategory,
                    clickedTyreSize,
                  });
                  const raw = modalResponse?.data ?? [];
                  const transformedData = transformDataForExcel(raw, true);

                  const n = raw.length;
                  const sum = (key) => raw.reduce((a, r) => a + (Number(r[key]) || 0), 0);
                  const avg = (key) => (n ? (sum(key) / n).toFixed(2) : "N/A");

                  setModalData({
                    title: "Milage Analysis - CPKM",
                    data: transformedData,
                    footer: [
                      { title: "Avg Original NSD", value: avg("Original NSD") },
                      { title: "Avg NSD", value: avg("averageNSD") },
                      { title: "Avg Percentage Wear", value: avg("Percentage Wear") },
                      { title: "Avg TotalKm", value: avg("totalKillometerTravelled") },
                      { title: "Avg Projection KM", value: avg("projectionKm") },
                    ],
                  });
                } catch (err) {
                  setModalData({ title: "Milage Analysis - CPKM", data: [], footer: [] });
                } finally {
                  setModalLoading(false);
                }
              }}
              options={{
                barThickness: 30,
                maintainAspectRatio: false,
                responsive: true,
                indexAxis: 'y',
                scales: {
                  x: {
                    grid: { display: true },
                    bounds: 'data',
                    ticks: {
                      font: {
                        family: 'Inter',
                        size: 14,
                      },
                    },
                    stacked: true,
                    position: 'bottom',
                  },
                  y: {
                    grid: { display: false },
                    ticks: {
                      stepSize: 10,
                      font: {
                        family: 'Inter',
                        size: 14,
                      },
                    },
                    stacked: true,
                  },
                },
                plugins: {
                  datalabels: {
                    anchor: 'auto',
                    align: 'auto',
                    display: true,
                    color: "black",
                    font: {
                      family: 'Inter',
                      size: 14,
                    },
                    formatter: (value, context) => {
                      const { datasetIndex, dataIndex: eleIndex } = context;
                      const data = chartData.datasets[datasetIndex].values?.[eleIndex];
                      const percentage = parseInt(chartData.datasets[datasetIndex].data?.[eleIndex], 10) || 0;
                      if (!data) return "";
                      if (percentage < 20 && !strikethroughLabels?.length) return "";
                      return String(data);
                    }
                  },
                  title: {
                    display: true,
                    text: "Milage Analysis - CPKM",
                    font: {
                      size: 14,
                      family: "Inter"
                    }
                  },
                  legend: {
                    display: true,
                    position: "bottom",
                    onClick: (e, legendItem) => {
                      // Handle the legend click event
                      const index = legendItem.index;
                      console.log(index);

                      const chart = chartRef.current;
                      const datasetVisible = chart.isDatasetVisible(index);

                      if (datasetVisible) {
                        chart.hide(index); // Hide dataset if it is visible
                      } else {
                        chart.show(index); // Show dataset if it is hidden
                      }

                      setStrikethroughLabels((prev) =>
                        prev.includes(index)
                          ? prev.filter((i) => i !== index)
                          : [...prev, index]
                      );
                    },
                    labels: {
                      generateLabels: (chart) => {
                        console.log(chart.data);
                        return chart.data.datasets.map(
                          ({ label }, index) => ({
                            text: label,
                            font: {
                              style: strikethroughLabels.includes(index)
                                ? "italic"
                                : "normal",
                              decoration: strikethroughLabels.includes(index)
                                ? "line-through"
                                : "none",
                            },
                            hidden: chart.isDatasetVisible(index)
                              ? false
                              : true, // Dynamically set visibility
                            fillStyle: BARCHARTCOLORS[indexOf[label]],
                            borderWidth: 0,
                            // hidden: false,
                            index,
                          })
                        );
                      },
                    },
                  },
                  tooltip: {
                    callbacks: {
                      label: (tooltipItem) => {
                        let label = chartData.datasets[tooltipItem.dataIndex]?.label || '';
                        if (label) label += ': ';
                        const value = chartData.datasets[tooltipItem.datasetIndex]?.data[tooltipItem.dataIndex];
                        const avgMilage = chartData.datasets[tooltipItem.datasetIndex]?.averageMilage[tooltipItem.dataIndex];
                        label += `${value}% \nAverage Milage: ${avgMilage}`;
                        return label;
                      },
                      labelColor: () => ({
                        borderColor: 'rgb(0, 0, 255)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderWidth: 2,
                        borderDash: [2, 2],
                        borderRadius: 2,
                      }),
                      labelTextColor: () => 'white',
                    }
                  }
                },
              }}
              plugins={[ChartDataLabels]}
            />
          </ResponsiveContainer>
        </div>
      )}
    </Box>
  );
};


const renderActiveShape = (props) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value
  } = props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 15}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const CustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, name }) => {
  // Anchor to the slice's own geometry (recharts passes cx/cy/outerRadius in for
  // every slice). The label sits just outside the arc with a short leader line,
  // and is anchored towards the centre so it grows inwards and never runs past
  // the edge of the card.
  const RAD = Math.PI / 180;
  const cos = Math.cos(-midAngle * RAD);
  const sin = Math.sin(-midAngle * RAD);
  const isRight = cos >= 0;

  const sx = cx + outerRadius * cos;
  const sy = cy + outerRadius * sin;
  const mx = cx + (outerRadius + 14) * cos;
  const my = cy + (outerRadius + 14) * sin;
  const ex = mx + (isRight ? 1 : -1) * 10;

  return (
    <g>
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${my}`} stroke="#9ca3af" fill="none" />
      <text
        x={ex + (isRight ? 4 : -4)}
        y={my}
        textAnchor={isRight ? "start" : "end"}
        dominantBaseline="central"
        fontSize={12}
        fill="#374151"
      >
        <tspan x={ex + (isRight ? 4 : -4)} dy="-0.6em">{`${name}`}</tspan>
        <tspan x={ex + (isRight ? 4 : -4)} dy="1.2em">
          {`(${value}W, ${(percent * 100).toFixed(1)}%)`}
        </tspan>
      </text>
    </g>
  );
};

const CustomizedLabelScrap = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, value, label, key, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
  const x = cx + (radius + 20) * Math.cos(-midAngle * (Math.PI / 180));
  const y = cy + (radius + 50) * Math.sin(-midAngle * (Math.PI / 180));

  // Adjust the x position based on whether the label is on the right or left side of the pie chart
  const adjustedX = 0;
  //  x > cx ? x + 70 : x + 70;
  const adjustedY = 0;
  // y > cy ? y + 10 : y + 0;

  // console.log({name, midAngle, radius, innerRadius, outerRadius, cx, cy, x, y})
  return (
    <g >
      <text dy="1.2em" x={x} y={y} textAnchor={x > cx ? "center" : "end"}>
        <tspan >{`${value}`}{` (${(percent * 100).toFixed(1)}%)`}</tspan>
      </text>
    </g>
  );
};


const NSDDistributionChart = ({ selectedFleets, selectedConfigurations, contractType, fetch, setModalData, selectedHubs, selectedProducts, selectedSizes, dateFrom, dateTo, selectedCPKMProducts, selectedCPKMSizes, getFleetOptions, getHubOptions }) => {
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [excludeFitment, setExcludeFitment] = useState(false)
  const [activeIndex, setActiveIndex] = useState(null);

  const getModalFilters = useCallback(() => ({
    ...(selectedFleets !== "all"
      ? { fleets: selectedFleets }
      : { fleets: getFleetOptions()?.filter((d) => d.value !== "all")?.map((d) => d.value).join(",") }),
    ...(selectedHubs !== "all"
      ? { hubs: selectedHubs }
      : { hubs: getHubOptions()?.filter((d) => d.value !== "all")?.map((d) => d.value).join(",") }),
    ...(selectedConfigurations.length && {
      makes: selectedConfigurations.map((make) => make).join(","),
    }),
    ...(selectedCPKMProducts.length && {
      cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(","),
    }),
    ...(selectedProducts.length && {
      products: selectedProducts
        .filter((item) => item.type === "NON CPKM")
        ?.flatMap((make) => make.meta.ids)
        .join(","),
    }),
    ...(selectedSizes.length && {
      tyreSize: selectedSizes.map((make) => make).join(","),
    }),
    ...(contractType && { contractType }),
    ...(dateFrom && { dateFrom }),
    ...(dateTo && { dateTo }),
  }), [
    selectedFleets,
    selectedHubs,
    selectedConfigurations,
    selectedCPKMProducts,
    selectedProducts,
    selectedSizes,
    contractType,
    dateFrom,
    dateTo,
    getFleetOptions,
    getHubOptions,
  ]);

  const onPieEnter = async (_, clickedIndex) => {
    const clickedSlice = chartData?.[clickedIndex];
    const nsdRange = clickedSlice?.name;
    if (!nsdRange) return;

    setModalLoading(true);
    try {
      const modalResponse = await createDocument("/dashboard/nsd/modalInfo", {
        ...getModalFilters(),
        nsdRange,
      });
      setModalData({
        title: "NSD Distribution",
        data: modalResponse?.data ?? [],
      });
    } catch (err) {
      setModalData({
        title: "NSD Distribution",
        data: [],
      });
    } finally {
      setModalLoading(false);
    }
  };
  const getData = async () => {
    setIsLoading(true);
    try {
      const dt = await createDocument("/dashboard/nsd", {
        ...getModalFilters(),
      });
      const summary = dt?.data?.[0] ?? {
        lessThan4: 0,
        lessThan4Data: [],
        between4And8: 0,
        between4And8Data: [],
        greaterThan8: 0,
        greaterThan8Data: [],
      };
      // // console.log(dt)
      setchartData([
        {
          name: "< 4",
          value: summary.lessThan4,
          data: summary.lessThan4Data,
        },
        {
          name: "4 - 8",
          value: summary.between4And8,
          data: summary.between4And8Data,
        },
        {
          name: ">=8",
          value: summary.greaterThan8,
          data: summary.greaterThan8Data,
        },
      ]);
    } catch (err) {
      setchartData(null)
    }
    setIsLoading(false);
  };


  useMemo(() => {
    if (fetch) getData()
  }, [fetch, excludeFitment])

  const RADIAN = Math.PI / 180;
  return <div className="relative w-full h-full items-center p-2 text-center justify-center mx-auto" id="nsd-graph" style={{ width: '100%', overflowX: 'auto', boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "850px" }}>
    {isLoading ? <Loading></Loading> : chartData &&
      <ResponsiveContainer
        width="100%" height={400}  //  overflow = "scroll"
      >
        <div className="text-gray-500 inter font-bold text-[14px]"> NSD Distribution</div>
        <PieChart>
          <Pie
            dataKey="value"
            // activeIndex={activeIndex}
            data={chartData}
            cx="50%"
            cy="50%"
            // 52% (was 70%) leaves a gutter wide enough for the outside labels,
            // which were previously clipped by the right edge of the card.
            outerRadius={"52%"}
            innerRadius={"24%"}
            fill="#8884d8"
            paddingAngle={0}
            labelLine={false}
            label={(entry) => (
              <CustomizedLabel
                cx={entry.cx}
                cy={entry.cy}
                midAngle={entry.midAngle}
                innerRadius={entry.innerRadius}
                outerRadius={entry.outerRadius}
                value={entry.value}
                name={entry.name}
                percent={entry.percent}
                index={entry.index}
              />
            )}
            onClick={onPieEnter}
          // activeShape={activeIndex!== undefined && renderActiveShape}
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip fill={"black"}
            content={({ payload }) => (
              <div style={{ background: 'rgba(0,0,0,0.8)', padding: '2px', color: "white", borderRadius: '5px' }}>
                <p>{`${payload[0]?.payload.name}: ${payload[0]?.payload.value}`}</p>
              </div>
            )} />
          <Legend align="center" verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    }
    {modalLoading && (
      <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-10">
        <Loading />
      </div>
    )}
  </div>
}

const ScrapAnalysis = ({ selectedFleets, selectedConfigurations, contractType, fetch, setModalData, selectedHubs, selectedProducts, selectedSizes, dateFrom, dateTo, selectedCPKMProducts, selectedCPKMSizes, getFleetOptions, getHubOptions }) => {
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [excludeFitment, setExcludeFitment] = useState(false)
  const [activeIndex, setActiveIndex] = useState(null);
  const [total, setTotal] = useState(1)
  const onPieEnter = (index, data) => {
    // console.log('onPieClick', index.value, data);
    const dt = chartData.filter((val, index) => index === data);
    // console.log({dt})
    setModalData({ title: "Scrap Analysis", data: dt[0].data })
  }
  const getData = async () => {
    setIsLoading(true);
    try {
      const dt = await createDocument("/dashboard/mobility/scrap-analysis", {
        ...(selectedFleets !== "all" ? {
          fleets: selectedFleets
        } : { fleets: getFleetOptions()?.filter(data => data.value!== "all")?.map(data => { return data.value }).join(",") }),
        ...(selectedHubs !== "all" ? {
          hubs: selectedHubs
        } : { hubs: getHubOptions()?.filter(data => data.value!== "all")?.map(data => { return data.value }).join(",") }),
        ...(selectedConfigurations.length && {
          makes: selectedConfigurations.map((make) => make).join(","),
        }),
        ...(selectedCPKMProducts.length && {
          cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(","),
        }),
        ...(selectedProducts.length && {
          products: selectedProducts.filter(item => item.type === "NON CPKM")?.flatMap((make) => make.meta.ids).join(","),
        }),
        ...(selectedSizes.length && {
          tyreSize: selectedSizes.map((make) => make).join(","),
        }),
        ...(contractType && { contractType }),
        ...dateFrom && { dateFrom },
        ...dateTo && { dateTo }
      });
      // console.log(dt)
      setchartData(
        dt.data?.map(item => {
          // // console.log({
          //   value: Number(parseFloat((item.tyres?.length / dt.total) * 100).toFixed(4))
          // })
          return {
            name: item._id?.reason ?? "---",
            value: Number(parseFloat((item.tyres?.length / 100) * 100).toFixed(4)),
            data: item.tyres
          }
        })
      )
      setTotal(dt.total)

    } catch (err) {
      setchartData(null)

    }
    setIsLoading(false);
  };

  useMemo(() => {
    if (fetch) getData()
  }, [fetch, excludeFitment])

  // // console.log({scrapChartData: chartData})
  // console.log("BOX HEIGHT", document.getElementById("scrap-graph")?.clientHeight)
  // console.log("BOX WIDTH", document.getElementById("scrap-graph")?.clientWidth)
  const RADIAN = Math.PI / 180;
  return <div className="w-full h-full items-center p-2 text-center justify-center mx-auto" id="scrap-graph" style={{ width: '100%', overflowX: 'auto', boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "850px" }}>
    {isLoading ? <Loading></Loading> : chartData &&
      <ResponsiveContainer
        width="100%" height={400}  //  overflow = "scroll"
      >
        <div className="text-gray-500 inter font-bold text-[14px] text-center mx-auto"> Scrap Analysis</div>
        <PieChart>
          <Pie
            dataKey="value"
            data={chartData}
            cx="50%"
            cy="45%"
            outerRadius={"70%"}
            innerRadius={"30%"}
            fill="#8884d8"
            paddingAngle={0}
            label={(entry) => (
              <CustomizedLabelScrap
                cx={0.52 * document.getElementById("scrap-graph").clientHeight}
                cy={0.28 * document.getElementById("scrap-graph").clientWidth}
                midAngle={entry.midAngle}
                innerRadius={entry.innerRadius}
                outerRadius={entry.outerRadius}
                value={entry.value}
                name={entry.name}
                percent={entry.percent}
                index={entry.index}
              />
            )}
            // label
            onClick={onPieEnter}
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={COLORS[(index + 1) % COLORS.length]}
                label={`Custom: ${entry.name}`}
              />
            ))}
          </Pie>
          <Tooltip fill={"black"}
            content={({ payload }) => (
              <div style={{ background: 'rgba(0,0,0,0.8)', padding: '2px', color: "white", borderRadius: '5px' }}>
                <p>{`${payload[0]?.payload.name}: ${payload[0]?.payload.value}`}</p>
              </div>
            )} />
          <Legend
            align="center"
            verticalAlign="bottom"
            height={64}
            wrapperStyle={{ overflowX: 'scroll', height: 'auto', fontSize: '12px' }}
          // Apply CSS styles to the ul tag inside the legend
          // content={<ul style={{ display: 'flex', flexDirection: 'row', margin: 0, padding: 0, listStyleType: 'none' }} />}
          />
        </PieChart>
      </ResponsiveContainer>
    }
    {/* </Box>  */}
  </div>
}

const ZoneChart = ({ isLoading, agreedCPKM, actualCPKM }) => {
  let percent = agreedCPKM ? parseInt(((Math.abs(actualCPKM) / agreedCPKM) * 100)) : 0;
  const color = percent < 80 ? "#1CE36980" : percent < 100 ? "#FA812880" : "#FF000080"
  // 00BFFF","#1CE369","#FA8128", "#933
  return (
    <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px", align: "center" }} className="w-full h-full items-center text-center">
      <div className="flex flex-row w-full h-[300px] items-center justify-center gap-1">
        <div className="rounded-md text-center w-36 h-36 bg-[#1CE36980]">
          <div className="flex flex-col gap-4 h-24 my-10 text-center items-center text-white font-bold text-lg">
            <p>
              Safe Zone
            </p>
            <p>
              {"< 80%"}
            </p>
          </div>
        </div>
        <div className="rounded-md text-center w-36 h-36 bg-[#FA812880]">
          <div className="flex flex-col gap-4 h-24 my-10 text-center items-center text-white font-bold text-lg">
            <p>
              Alert Zone
            </p>
            <p>
              {"80 - 100%"}
            </p>
          </div>
        </div>
        <div className="rounded-md text-center w-36 h-36 bg-[#FF000080]">
          <div className="flex flex-col gap-4 h-24 my-10 text-center items-center text-white font-bold text-lg">
            <p>
              Red Zone
            </p>
            <p>
              {"> 100%"}
            </p>
          </div>
        </div>
      </div>
      {isLoading ? <Loading /> : <div className={`text-3xl font-semibold justify-center text-center items-center mx-auto w-32 p-4 bg-[${color}] rounded-lg shadow-[${color}] shadow-lg`}>
        <p>{percent}%</p>
      </div>}

    </Box>
  );
};
const Loading = () => {
  return <div>
    <span className="dot">.</span>
    <span className="dot">.</span>
    <span className="dot">.</span>
  </div>
}

export default MobilityDashboard;
